/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-continue */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-console */
import {
  useDatoClient,
  useTemplatedPrompts,
  useUserIdentity,
} from '@src/stores-v2/StoreContext';
import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';
import { analytics } from '@src/utility/analytics';
import { observer } from 'mobx-react-lite';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';

import ChatGPTService from '../../services/ChatGPTService';
import { initializeContentStudioContent } from '../../utility/general';
import { useFlagsCombination } from '../../utility/useFlagsCombination';
import SpinningLoading from '../SpinningLoading';
import AIProducerModal from './AIProducerModal';
import BrandVoiceRevisionModal from './BrandVoiceRevisionModal';
import ContentActions from './ContentActions';
import QuoteCard from './QuoteCard';

import type { Artifact } from '../../types.ts/story';
import type { AudienceOption } from '../common/AudienceSelector';
import type { GoalOption } from '../common/GoalSelector';
import type { Speaker } from './SpeakerTypes';
import type { AIPrompt } from '@src/types.ts/ai_prompts';
import type { FC } from 'react';

const PullQuotes: FC<{}> = observer(() => {
  const videoCreator = useVideoCreatorStore();
  const datoClientStore = useDatoClient();
  const userIdentity = useUserIdentity();
  const gptServiceRef = useRef(
    new ChatGPTService(videoCreator, datoClientStore.aiPromptRepository),
  );
  const gptService = gptServiceRef.current;
  const [isLoading, setIsLoading] = useState(false);
  const [isRegenerating, setIsRegenerating] = useState(false);
  const [selectedSpeakers, setSelectedSpeakers] = useState<Speaker[]>([]);
  const [selectedGoal, setSelectedGoal] = useState<GoalOption | null>(null);
  const [selectedAudiences, setSelectedAudiences] = useState<AudienceOption[]>(
    [],
  );
  const { story, unsavedShareableImages } = videoCreator;
  const { enableShareableImageRegeneration } = useFlagsCombination(
    userIdentity.currentRole,
  );

  useEffect(() => {
    initializeContentStudioContent(videoCreator, story?.id, 'Quotes');
  }, [story?.id]);

  const contentGenerated = videoCreator.contentStudioGeneratedContent;

  const [loadingStock, setLoadingStock] = useState(false);

  const generatedContent = contentGenerated?.Quotes?.content?.response;
  const hasBeenGenerated = contentGenerated?.Quotes?.hasBeenGenerated;
  const usedSpeakers = contentGenerated?.Quotes?.usedSpeakers;
  const generatedContentLanguage =
    contentGenerated?.Quotes?.selectedLanguage || null;

  const artifacts = (
    story?.storyArtifacts?.map((artifact: Artifact) => {
      if (artifact.responsiveImage) {
        return artifact;
      }
    }) || []
  ).filter(Boolean);
  const organizationArtifacts =
    story?._allReferencingShowcases?.flatMap((album: any) =>
      (album.organizationArtifacts || []).filter((a: any) => a.responsiveImage),
    ) || [];
  const assets = (
    story?.storyAssets?.map(asset => {
      if (asset.responsiveImage) {
        return asset;
      }
    }) || []
  ).filter(Boolean);

  useEffect(() => {
    let quoteList = generatedContent as string[];
    if (typeof generatedContent === 'string') {
      quoteList = (generatedContent as string)
        ?.split('\n')
        .filter(q => q.trim()) as string[];
    }

    const saved = story?.shareableImages || [];

    const unsaved: any = [];
    const stillImages = [...artifacts, ...assets, ...organizationArtifacts];
    for (const [index, quote] of (quoteList || []).entries()) {
      const image = (
        stillImages.length ? stillImages[index % stillImages.length] : null
      ) as Artifact | null;

      const isInCard = saved.some(
        q =>
          q.quote?.trim() === quote.trim() &&
          q.imagefile?.url === (image?.url || ''),
      );

      if (isInCard) continue;

      let cleanedQuote = quote?.replace(/^["'\s-]+|["'\s-]+$/g, '')?.trim();
      let storytellerName = story?.storyTeller?.name;

      if (selectedSpeakers.length > 0 || usedSpeakers) {
        // Parse the quote to extract speaker name using the " --- Speaker Name" format
        const attributionRegex = /^(.*?)\s+---\s+(.+)$/;
        const match = cleanedQuote.match(attributionRegex);

        if (match && match[2]) {
          // Speaker name found in the format " --- Speaker Name"
          // Trim any extra quote characters that might be present in the speaker name
          storytellerName = match[2].trim().replace(/["']/g, '');
          // Remove the speaker attribution from the quote
          cleanedQuote = match[1].trim();
          // console.log(`Extracted speaker "${storytellerName}" from quote`);
        } else {
          // console.log(`No speaker attribution found in quote: "${quote.substring(0, 100)}..."`);
        }
      }

      unsaved.push({
        id: uuid(),
        quote: cleanedQuote?.replace(/^["'\s-]+|["'\s-]+$/g, '')?.trim(),
        storytellerName,
        ...(image && {
          imagefile: {
            ...image,
          },
        }),
      });
    }

    videoCreator.unsavedShareableImages = unsaved;
  }, [generatedContent, selectedSpeakers, usedSpeakers]);

  const getLoadingText = () => {
    if (loadingStock) {
      return 'Loading stock photo...';
    }
    if (isRegenerating) {
      return 'Regenerating shareable images...';
    }
    return 'Generating shareable images...';
  };

  const { aiShareableImagesTemplates } = useTemplatedPrompts();
  const [aiProducerOpen, setAiProducerOpen] = useState(false);
  const [promptTemplate, setPromptTemplate] = useState<AIPrompt | undefined>();
  const [customPrompt, setCustomPrompt] = useState<string | undefined>();
  const handleGenerate = async (
    template?: AIPrompt,
    brandVoice?: string,
    customInstructions?: string,
    avoidWords?: string,
    chosenSpeakers: Speaker[] = [],
    selectedGoal?: GoalOption | null,
    selectedAudiences?: AudienceOption[],
    selectedLanguage?: string,
  ) => {
    setIsLoading(true);
    setIsRegenerating(false);
    setSelectedSpeakers(chosenSpeakers);
    if (selectedGoal) setSelectedGoal(selectedGoal);
    if (selectedAudiences) setSelectedAudiences(selectedAudiences);

    analytics.track('generate_quotes', {
      storyId: story?.id,
      storyTitle: videoCreator.story?.title,
      template,
      customInstructions,
      brandVoice,
      speakerFiltering: !!chosenSpeakers,
      speakerCount: chosenSpeakers?.length,
      selectedLanguage,
    });
    await gptService.regenerateStreamResponse({
      key: 'Quotes',
      type: 'new',
      setLoading: setIsLoading,
      template,
      customInstructions,
      brandVoice,
      avoidWords,
      selectedSpeakers: chosenSpeakers,
      selectedGoal,
      selectedAudiences,
      selectedLanguage,
    });
    if (customInstructions) {
      setCustomPrompt(customInstructions);
    } else if (template) {
      setPromptTemplate(template);
    }
  };

  const [revisionModalOpen, setRevisionModalOpen] = useState(false);
  const handleRegenerate = async (
    revision: string,
    options: { selectedLanguage?: string | null },
  ) => {
    setIsLoading(true);
    setIsRegenerating(true);
    setRevisionModalOpen(false);
    analytics.track('regenerate_quotes', {
      storyId: story?.id,
      storyTitle: videoCreator.story?.title,
      template: promptTemplate,
      customInstructions: customPrompt,
      revision,
    });
    await gptService.regenerateStreamResponse({
      key: 'Quotes',
      type: 'regenerate',
      setLoading: setIsLoading,
      template: promptTemplate,
      customInstructions: customPrompt,
      revision,
      selectedSpeakers,
      selectedGoal,
      selectedAudiences,
      selectedLanguage: options.selectedLanguage || generatedContentLanguage,
    });
  };

  return (
    <Main>
      {((isLoading && !generatedContent) || loadingStock) && (
        <SpinningLoading
          customStyle={{
            top: 0,
            position: 'fixed',
            alignItems: 'center',
          }}
          text={getLoadingText()}
        />
      )}
      {enableShareableImageRegeneration && (
        <ContentActions
          hasBeenGenerated={hasBeenGenerated}
          onGenerate={() => setAiProducerOpen(true)}
          onRegenerate={() => setRevisionModalOpen(true)}
        />
      )}
      <Quotes>
        {story?.shareableImages?.map(content => (
          <QuoteCard
            key={content.id}
            id={content.id}
            text={content.quote}
            isSaved
            imageFile={content.imagefile}
            storytellerName={content.storytellerName}
            setLoadingStock={setLoadingStock}
            allReferencingCaptions={content._allReferencingCaptions}
            allReferencingSharedContents={content._allReferencingSharedContents}
          />
        ))}
        {hasBeenGenerated &&
          unsavedShareableImages?.map((content, index) => (
            <QuoteCard
              key={index}
              text={content.quote}
              id={content.id}
              isSaved={false}
              imageFile={content.imagefile}
              storytellerName={content.storytellerName}
              setLoadingStock={setLoadingStock}
            />
          ))}
      </Quotes>

      {aiProducerOpen ? (
        <AIProducerModal
          customType="Quotes"
          title="Let’s find some quotes"
          templatesSublabel="Theme"
          templates={aiShareableImagesTemplates || []}
          onClose={() => setAiProducerOpen(false)}
          onConfirm={handleGenerate}
          allowBrandVoice={false}
          enableSpeakerSelection // Enable speaker selection for quotes
        />
      ) : null}

      {revisionModalOpen ? (
        <BrandVoiceRevisionModal
          title="Regenerate quotes"
          selectedLanguage={generatedContentLanguage}
          onClose={() => setRevisionModalOpen(false)}
          handleGenerate={handleRegenerate}
        />
      ) : null}
    </Main>
  );
});

export default PullQuotes;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  gap: 20px;
  .buttons {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
  }
`;

const Quotes = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin: 0 auto;
  @media only screen and (min-width: 1800px) {
    gap: 50px;
  }
`;
